const editionTypeId = 1

module.exports = {
    editionTypeId
}